import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useEditRequest, useGetRequests, useRequestActions } from 'src/components/hooks';
import { useSpinner } from 'src/components/hooks/useExtraStore';

import {
  Container,
  TableNoData,
  useTable,
  Card,
  Scrollbar,
  CustomBreadcrumbs,
} from 'src/components/ui';

import { RequestDrawer } from './RequestDrawer';
import { RequestsHead } from './RequestsHead';
import { RequestsRow } from './RequestsRow';
import { RequestsPagination } from './RequestsPagination';

export const RequestsTable = () => {
  const { getRequests, data } = useGetRequests();
  const { isStatusChanged, isRequestDeleted } = useRequestActions();
  const { isRequestEdited } = useEditRequest();
  const { setSpinner } = useSpinner();

  const table = useTable();

  useEffect(() => {
    setSpinner(true);
    getRequests(table.page, table.rowsPerPage);
  }, [table.page, table.rowsPerPage, isStatusChanged, isRequestDeleted, isRequestEdited]);

  return (
    <>
      <Helmet>
        <title>Request List</title>
      </Helmet>
      <Container maxWidth="xl">
        <CustomBreadcrumbs
          heading="Requests List"
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />

        <Card>
          <Scrollbar>
            <RequestsHead />
            {data.items?.map((row) => (
              <RequestsRow key={row.id} row={row} />
            ))}

            <TableNoData notFound={!data.items?.length} />
          </Scrollbar>

          <RequestsPagination
            count={data.meta?.totalItems}
            page={table.page}
            rowsPerPage={table.rowsPerPage}
            onPageChange={table.onChangePage}
            onRowsPerPageChange={table.onChangeRowsPerPage}
            dense={table.dense}
            onChangeDense={table.onChangeDense}
          />
          <RequestDrawer />
        </Card>
      </Container>
    </>
  );
};
